import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const SUBSCRIBE = 'CHANNELS/SUBSCRIBE';

export const subscribeActionSchema = objectSchemaOf<ISubscribeAction>({
  type: Joi.string().required().valid(SUBSCRIBE),
  payload: objectSchemaOf<ISubscribeAction['payload']>({
    channels: Joi.array().items(Joi.string()).min(1).required(),
  }),
});

export interface ISubscribeAction {
  type: typeof SUBSCRIBE;
  payload: {
    channels: string[];
  };
}

export const subscribe = actionCreator({
  type: SUBSCRIBE,
  schema: subscribeActionSchema,
  creator: (channels: string[]): ISubscribeAction => ({
    type: SUBSCRIBE,
    payload: {
      channels,
    },
  }),
});
